import {
  Form, App
} from "antd";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";
import useAssistance from "../../hooks/useAssistance";
import { SEND_SUPPORT_EMAIL } from "./assistanceModal.qql";

const AssistanceModal = () => {
  const { isAssistantModalOpen, toggleAssistModal } = useAssistance();
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { message } = App.useApp();

  const [sendSupportEmail, { loading }] = useMutation(SEND_SUPPORT_EMAIL, {
    fetchPolicy: "no-cache",
    onCompleted() {
      message.success(t("dashboardPage.support.successMessage"));
      toggleAssistModal();
    },
    onError() {
      message.error(t("global.error.fetchError"));
    }
  });

  const handleSubmit = (values: {
    name: string;
    surname: string;
    email: string;
    message: string;
  }) => {
    sendSupportEmail({
      variables: {
        ...values
      }
    });
  };

  const data = [
    {
      label: t("form.label.name"),
      name: "name",
      rules: [{ required: true, message: t("form.error.name") }],
      layout: 12,
    },
    {
      label: t("form.label.surname"),
      name: "surname",
      rules: [{ required: true, message: t("form.error.surname") }],
      layout: 12,
    },
    {
      label: t("form.label.email"),
      name: "email",
      rules: [{
        required: true,
        message: t("form.error.email")
      }],
      layout: 24,
    },
    {
      label: t("form.label.message"),
      name: "message",
      rules: [{ required: true, message: t("form.error.message") }],
      layout: 24,
    },
  ];

  return {
    isAssistantModalOpen,
    toggleAssistModal,
    form,
    data,
    sendSupportEmail,
    loading,
    handleSubmit
  };
};

export default AssistanceModal;
